module.exports = __webpack_public_path__ + "assets/fonts/arrow-right.d4f419dc.svg";